<template>
  <v-col class="col-6 mx-auto d-flex justify-center">
    <v-row v-if="generalParameters">
      <v-col v-if="!deshabilitarBtnAgregador">
        <v-img
          :src="generalParameters.urlBtnAgregador"
          width="300"
          height="60"
          class="mx-auto rounded btn"
          @click="abrirPasarelaAgregador"
        />
      </v-col>
      <v-col v-if="!deshabilitarBtnGateway">
        <v-img
          :src="generalParameters.urlBtnGateway"
          width="300"
          height="60"
          class="mx-auto rounded btn"
          @click="abrirPasarelaGateway"
        />
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
import { mapState } from 'vuex'
import { SHOW_ALERT } from '@/store/mutations-types'
import {
  EPAYCO_TEST_MODE,
  METHODS_DISABLE_AGREGADOR,
  METHODS_DISABLE_GATEWAY
} from './data/constants'
/* global ePayco */
export default {
  name: 'BotonesEpayco',
  props: {
    value: {
      type: Object,
      required: true,
      description: 'Modelo de datos epayco checkout'
    },
    datosObra: {
      type: Object,
      default: () => { return { identificadorVid: null } },
      descripcion: 'Info obra para configurar pasarela epayco'
    },
    validarFormulario: {
      type: Function,
      default: () => true,
      descripcion: 'Valida el formulario de datos para el pago'
    },
    deshabilitarBtnAgregador: {
      type: Boolean,
      default: false,
      description: 'Modelo de datos epayco checkout'
    },
    deshabilitarBtnGateway: {
      type: Boolean,
      default: false,
      description: 'Modelo de datos epayco checkout'
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(['generalParameters'])
  },
  methods: {
    async ePaycoInitPasarelaAgregador ({ publicKeyAgregador }) {
      // console.log('publicKeyAgregador: ', publicKeyAgregador)
      if (!this.deshabilitarBtnAgregador && publicKeyAgregador) {
        return ePayco.checkout.configure({
          key: publicKeyAgregador,
          test: EPAYCO_TEST_MODE
        })
      }

      this.$store.commit(SHOW_ALERT, {
        type: 'error',
        text: this.$t('mensaje_error.obra_no_valida'),
        show: true
      })
    },
    async ePaycoInitPasarelaGateway ({ publicKeyGateway }) {
      // console.log('publicKeyGateway: ', publicKeyGateway)
      if (!this.deshabilitarBtnGateway && publicKeyGateway) {
        return ePayco.checkout.configure({
          key: publicKeyGateway,
          test: EPAYCO_TEST_MODE
        })
      }

      this.$store.commit(SHOW_ALERT, {
        type: 'error',
        text: this.$t('mensaje_error.obra_no_valida'),
        show: true
      })
    },
    async abrirPasarelaAgregador () {
      if (await this.validarFormulario()) {
        const handlerPasarelaAgregador = await this.ePaycoInitPasarelaAgregador(this.datosObra)
        this.abrirCheckoutEpayco(handlerPasarelaAgregador, METHODS_DISABLE_AGREGADOR)
      }
    },
    async abrirPasarelaGateway () {
      if (await this.validarFormulario()) {
        const handlerPasarelaGateway = await this.ePaycoInitPasarelaGateway(this.datosObra)
        this.abrirCheckoutEpayco(handlerPasarelaGateway, METHODS_DISABLE_GATEWAY)
      }
    },
    async abrirCheckoutEpayco (handler, methodsDisable) {
      if (handler) {
        handler.open({ ...this.value, methodsDisable })
        return null
      }

      this.$store.commit(SHOW_ALERT, {
        type: 'error',
        text: this.$t('mensaje_error.error_iniciar_pasarela'),
        show: true
      })
    }
  }
}
</script>
<i18n src="./data/i18n.json" type="text/json" />

<style lang="scss" scoped>
  .btn:hover {
    cursor: pointer !important;
  }
</style>
